import { createContext, useContext, useState, useCallback } from "react";
import ConfirmModal from "../components/ui/ConfirmModal";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
 const [modalState, setModalState] = useState({
 isOpen: false,
 title: "",
 message: "",
 onConfirm: null,
 onCancel: null,
 confirmText: "Confirmer",
 cancelText: "Annuler",
 type: "primary", // primary | danger
 });

 const confirm = useCallback((options) => {
 return new Promise((resolve) => {
 setModalState({
 isOpen: true,
 title: options.title || "Confirmation",
 message: options.message || "Êtes-vous sûr de vouloir continuer ?",
 confirmText: options.confirmText || "Confirmer",
 cancelText: options.cancelText || "Annuler",
 type: options.type || "primary",
 onConfirm: () => {
 if (options.onConfirm) options.onConfirm();
 resolve(true);
 setModalState((prev) => ({ ...prev, isOpen: false }));
 },
 onCancel: () => {
 resolve(false);
 setModalState((prev) => ({ ...prev, isOpen: false }));
 }
 });
 });
 }, []);

 return (
 <ModalContext.Provider value={{ confirm }}>
 {children}
 <ConfirmModal 
 isOpen={modalState.isOpen}
 title={modalState.title}
 message={modalState.message}
 confirmText={modalState.confirmText}
 cancelText={modalState.cancelText}
 type={modalState.type}
 onConfirm={modalState.onConfirm}
 onCancel={modalState.onCancel}
 />
 </ModalContext.Provider>
 );
};
